<template>
    <div class="selectMenu" v-bind:style="{width}">
        <span class="text" v-html="content" v-if="htmlMode">{{ content }}</span>
        <span class="text" v-else>{{ content }}</span>
        <img src="./img/greenButton.png" alt="greenButton" width="34px" height="28px">
    </div>
</template>

<script>

export default {
    name: 'ButtonSelector',
    props: {
        content: String,
        width: {
            type: String,
            default: '170px',
        },
        htmlMode: Boolean,
    },
};
</script>

<style scoped>

    .selectMenu {
        font-size: 14px;
        height: 28px;
        background: #f7f7f7;
        color: #666;
        display: flex;
        justify-content: space-between;
        cursor: pointer;
        z-index: 5;
    }

    .text {
        align-self: center;
        white-space: nowrap;
        overflow: hidden;
        padding-left: 1%;
        text-overflow: ellipsis;
    }

    .selectMenu:hover {
        box-shadow: 0 0 4px #333;
    }
</style>
